<div class="inner">
    <div class="content"
         [elementHeight]="uid">
        <ng-content></ng-content>
    </div>
</div>